// Import all Stockfish icons
import bestIcon from '../images/StockfishIcons/Best.png';
import blunderIcon from '../images/StockfishIcons/Blunder.png';
import theoryIcon from '../images/StockfishIcons/Theory.png';
import brilliantIcon from '../images/StockfishIcons/Brilliance.png';
import greatIcon from '../images/StockfishIcons/Great.png';
import goodIcon from '../images/StockfishIcons/Good.png';
import interestingIcon from '../images/StockfishIcons/Excellent.png';
import mistakeIcon from '../images/StockfishIcons/Mistake.png';
import inaccuracyIcon from '../images/StockfishIcons/Inaccurate.png';
import missIcon from '../images/StockfishIcons/Miss.png';

// Emoji SVG definitions
const createSvgEmoji = (content) => {
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(content)}")`;
};

// Target emoji (existing)
const targetSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="red" /><circle cx="20" cy="20" r="10" fill="white" /><circle cx="20" cy="20" r="5" fill="red" /></svg>');

// Exclamation emoji (existing)
const exclamationSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="15" r="15" fill="#66ccff" /><text x="14" y="23" font-size="20" fill="white">!!</text></svg>');

// Additional emojis
const smileSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FFD700" /><circle cx="14" cy="15" r="2" fill="black" /><circle cx="26" cy="15" r="2" fill="black" /><path d="M12,24 Q20,30 28,24" stroke="black" fill="transparent" stroke-width="2" /></svg>');

const sadSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FFD700" /><circle cx="14" cy="15" r="2" fill="black" /><circle cx="26" cy="15" r="2" fill="black" /><path d="M12,28 Q20,22 28,28" stroke="black" fill="transparent" stroke-width="2" /></svg>');

const wowSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FFD700" /><circle cx="14" cy="15" r="2" fill="black" /><circle cx="26" cy="15" r="2" fill="black" /><circle cx="20" cy="25" r="5" fill="black" /></svg>');

const angrySvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FF6347" /><path d="M10,12 L15,15" stroke="black" stroke-width="2" /><path d="M30,12 L25,15" stroke="black" stroke-width="2" /><circle cx="14" cy="15" r="2" fill="black" /><circle cx="26" cy="15" r="2" fill="black" /><path d="M12,28 Q20,22 28,28" stroke="black" fill="transparent" stroke-width="2" /></svg>');

const loveSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FF69B4" /><path d="M14,13 L14,17 L10,15 Z" fill="red" /><path d="M26,13 L26,17 L30,15 Z" fill="red" /><path d="M12,24 Q20,30 28,24" stroke="black" fill="transparent" stroke-width="2" /></svg>');

const thinkingSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FFD700" /><circle cx="14" cy="15" r="2" fill="black" /><circle cx="26" cy="15" r="2" fill="black" /><path d="M25,28 Q32,25 32,22" stroke="black" fill="transparent" stroke-width="2" /><circle cx="33" cy="19" r="3" fill="white" stroke="black" /></svg>');

const laughSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FFD700" /><circle cx="14" cy="15" r="2" fill="black" /><circle cx="26" cy="15" r="2" fill="black" /><path d="M10,22 Q20,32 30,22" stroke="black" fill="black" /></svg>');

const surprisedSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FFD700" /><circle cx="14" cy="12" r="2" fill="black" /><circle cx="26" cy="12" r="2" fill="black" /><ellipse cx="20" cy="25" rx="5" ry="7" fill="black" /></svg>');

const confusedSvg = createSvgEmoji('<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60"><circle cx="20" cy="20" r="15" fill="#FFD700" /><circle cx="14" cy="15" r="2" fill="black" /><circle cx="26" cy="15" r="2" fill="black" /><path d="M12,26 Q17,24 20,26 Q23,28 28,26" stroke="black" fill="transparent" stroke-width="2" /></svg>');

// Export all icons
export const stockfishIcons = {
  best: bestIcon,
  blunder: blunderIcon,
  theory: theoryIcon,
  brilliant: brilliantIcon,
  great: greatIcon,
  good: goodIcon,
  interesting: interestingIcon,
  mistake: mistakeIcon,
  inaccuracy: inaccuracyIcon,
  miss: missIcon
};

export const emojiIcons = {
  target: targetSvg,
  exclamation: exclamationSvg,
  smile: smileSvg,
  sad: sadSvg,
  wow: wowSvg,
  angry: angrySvg,
  love: loveSvg,
  thinking: thinkingSvg,
  laugh: laughSvg,
  surprised: surprisedSvg,
  confused: confusedSvg
};

// Export style generators for both icon types
export const createStockfishIconStyle = (iconKey) => {
  return {
    backgroundImage: `url(${stockfishIcons[iconKey]})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 5px top 5px',
    backgroundSize: '24px',
    zIndex: 9999
  };
};

export const createEmojiStyle = (emojiKey) => {
  return {
    backgroundImage: emojiIcons[emojiKey],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '5px 2px',
    backgroundSize: '36px',
    zIndex: 9999
  };
};

// Pre-defined style objects
export const STOCKFISH_ICON_STYLES = {
  brilliant: createStockfishIconStyle('brilliant'),
  best: createStockfishIconStyle('best'),
  blunder: createStockfishIconStyle('blunder'),
  book: createStockfishIconStyle('theory'),
  great: createStockfishIconStyle('great'),
  good: createStockfishIconStyle('good'),
  interesting: createStockfishIconStyle('interesting'),
  mistake: createStockfishIconStyle('mistake'),
  inaccuracy: createStockfishIconStyle('inaccuracy'),
  miss: createStockfishIconStyle('miss')
};

export const EMOJI_STYLES = {
  target: createEmojiStyle('target'),
  exclamation: createEmojiStyle('exclamation'),
  smile: createEmojiStyle('smile'),
  sad: createEmojiStyle('sad'),
  wow: createEmojiStyle('wow'),
  angry: createEmojiStyle('angry'),
  love: createEmojiStyle('love'),
  thinking: createEmojiStyle('thinking'),
  laugh: createEmojiStyle('laugh'),
  surprised: createEmojiStyle('surprised'),
  confused: createEmojiStyle('confused')
}; 